import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";

// Connects to data-controller="image-preview"
export default class extends Controller {
  connect() {
    this.initSortable();
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy();
      this.sortable = null;
    }
  }

  initSortable() {
    if (this.sortable) {
      this.sortable.destroy();
    }

    const sortUrl = this.element.dataset.imagePreviewSortUrl;

    if (!sortUrl) return;

    this.sortable = Sortable.create(this.element, {
      handle: ".image-preview-wrapper",
      animation: 250,
      easing: "cubic-bezier(.22,.61,.36,1)",
      ghostClass: "image-preview-card--ghost",
      chosenClass: "image-preview-card--chosen",
      dragClass: "image-preview-card--dragging",
      onEnd: () => {
        this.saveOrder(sortUrl);
      },
    });
  }

  saveOrder(sortUrl) {
    const cards = this.element.querySelectorAll(".image-preview-card");
    const imageIds = Array.from(cards).map((card) => card.dataset.imageId);

    if (imageIds.length === 0) return;

    fetch(sortUrl, {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": document.querySelector('[name="csrf-token"]').content,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ image_ids: imageIds }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Falha ao salvar ordem (status ${response.status})`);
        }
        return response.json().catch(() => ({}));
      })
      .then(() => {
        this.updateMainBadge();
      })
      .catch((error) => {
        console.error("Erro ao salvar ordem das imagens:", error);
      });
  }

  updateMainBadge() {
    // Remove badges existentes
    this.element
      .querySelectorAll(".image-preview-main-badge")
      .forEach((badge) => badge.remove());

    // Adiciona badge ao primeiro card (nova imagem principal)
    const firstCard = this.element.querySelector(".image-preview-card");
    if (!firstCard) return;

    const info = firstCard.querySelector(".image-preview-info");
    if (!info) return;

    const badge = document.createElement("span");
    badge.className = "image-preview-main-badge";
    badge.textContent = "Imagem principal";

    info.prepend(badge);
  }

  remove(event) {
    event.preventDefault();
    const button = event.currentTarget;
    const imageCard = button.closest(".image-preview-card");
    const imageId = button.dataset.imageId;
    const prefixUrl = button.dataset.prefixUrl || "carros";
    window.Swal.fire({
      title: "Tem certeza?",
      text: "Tem certeza que deseja remover esta imagem?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim, remover",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (!result.isConfirmed) return;

      // Desabilita o botão durante a requisição
      button.disabled = true;
      button.style.opacity = "0.5";
      button.innerHTML = "Removendo...";

      // Pega o post ID do elemento pai
      const carId =
        imageCard.closest("[data-car-id]")?.dataset.carId ||
        button.dataset.carId;

      // Faz a requisição DELETE para o servidor
      // Use uma URL fornecida no botão se existir (gerada pelo Rails),
      // senão usa o caminho em português `/carros/...` (rota definida em routes)
      const url =
        button.dataset.deleteUrl ||
        `/${prefixUrl}/${carId}/delete_image?attachment_id=${imageId}`;

      fetch(url, {
        method: "DELETE",
        headers: {
          "X-CSRF-Token": document.querySelector('[name="csrf-token"]').content,
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          const contentType = response.headers.get("content-type") || "";
          if (!response.ok) {
            // Try to parse JSON error, otherwise throw with status
            if (contentType.includes("application/json")) {
              return response.json().then((err) => {
                throw err;
              });
            }
            throw new Error(`Request failed with status ${response.status}`);
          }

          // If response is JSON, parse it; otherwise resolve with an object
          if (contentType.includes("application/json")) {
            return response.json();
          }
          return { success: true };
        })
        .then((data) => {
          if (data && data.success) {
            // Animação de saída
            imageCard.style.opacity = "0";
            imageCard.style.transform = "scale(0.8)";

            setTimeout(() => {
              imageCard.remove();
            }, 300);
          } else {
            alert((data && data.message) || "Erro ao remover imagem");
            button.disabled = false;
            button.style.opacity = "1";
            button.innerHTML =
              '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>Remover';
          }
        })
        .catch((error) => {
          console.error("Erro:", error);
          // If server returned JSON error message, show it
          const msg =
            (error && error.message) ||
            "Erro ao remover imagem. Tente novamente.";
          alert(msg);
          button.disabled = false;
          button.style.opacity = "1";
          button.innerHTML =
            '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>Remover';
        });
    });
  }
}
